export const CONSUMER_STATUS_ACTIVE = 'ACTIVE'
export const CONSUMER_STATUS_INACTIVE = 'INACTIVE'

export const CONSUMER_STATUSES = [CONSUMER_STATUS_ACTIVE, CONSUMER_STATUS_INACTIVE]
